import { CarouselButtons, Stack, XStack, useCarousel } from '@my/ui'

import { OfferGridItem } from './offer-grid-item'

export const OfferGridList = ({ block }) => {
  const carousel = useCarousel()
  return (
    <Stack position="relative" overflow="hidden" w="100%" ref={carousel.emblaRef as any}>
      <XStack height="auto">
        {block.offerGridOffers.map((item, index) => (
          <Stack key={item.id} minWidth={0} flexGrow={0} flexShrink={0} pr="$3" overflow="hidden">
            <OfferGridItem {...item} imagePriority={index <= 4 && block.imagePriority} />
          </Stack>
        ))}
      </XStack>
      <CarouselButtons carousel={carousel} />
    </Stack>
  )
}
